// Centralized validators for reuse across components
const validators = {
  patient_name: (val) =>
    val.trim().length < 3 ? "Patient name must be at least 3 characters" : "",

  name: (val) =>
    val.trim().length < 2 ? "Name must be at least 2 characters" : "",
  org_name: (val) =>
    val.trim().length < 3 ? "Organization name must be at least 3 characters" : "",
  phone_number: (val) =>
    /^\d{10}$/.test(val) ? "" : "Phone number must be 10 digits",
  phone: (val) =>
    /^\d{10}$/.test(val) ? "" : "Phone number must be 10 digits",
  email: (val) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val) ? "" : "Enter a valid email",

  address: (val) => (val.trim().length === 0 ? "Address cannot be empty" : ""),

  date_of_birth: (val) => (!val ? "Date of Birth is required" : ""),

  gender: (val) => (!val ? "Please select gender" : ""),
  service_id: (val) => (!val ? "Please select service" : ""),
  therapy_days: (val) => (!val ? "Please select therapy days" : ""),

  country: (val) => (val.trim().length === 0 ? "Address cannot be empty" : ""),

  city: (val) => (val.trim().length === 0 ? "Address cannot be empty" : ""),

  postal_code: (val) =>
    val.trim().length === 0 ? "Address cannot be empty" : "",

  contact_number: (val) =>
    /^\d{10}$/.test(val) ? "" : "Contact number must be 10 digits",

  description: (val) =>
    val.trim().length < 10 ? "Description must be at least 10 characters" : "",

  consultation_fee: (val) =>
    /^\d+(\.\d{1,2})?$/.test(val)
      ? ""
      : "Consultation fee must be a valid number",
  total_sessions: (val) =>
    /^\d+$/.test(val) && parseInt(val, 10) > 0
      ? ""
      : "Total sessions must be a positive integer",
  frequency_per_week: (val) =>
    /^\d+$/.test(val) && parseInt(val, 10) > 0
      ? ""
      : "Total sessions must be a positive integer",
  therapy_session_fee: (val) =>
    /^\d+(\.\d{1,2})?$/.test(val)
      ? ""
      : "Therapy session fee must be a valid number",

  therapy_duration_minutes: (val) =>
    /^\d+$/.test(val) && parseInt(val, 10) > 0
      ? ""
      : "Therapy duration must be a positive integer",

  new_password: (val) =>
    val.trim().length < 3 ? "Password must be at least 3 characters" : "",
  confirm_passw0rd: (val) =>
    val.trim().length < 3 ? "Password name must be at least 3 characters" : "",
  password: (val) =>
    val.trim().length < 3 ? "Password must be at least 3 characters" : "",
  confirmPassword: (val) =>
    val.trim().length < 3 ? "Password must be at least 3 characters" : "",
  time_slot: (val) =>
    val.trim().length === 0 ? "Time Slot cannot be empty" : "",

};

export default validators;
